<template>
  <li class="tree-node-list-item">
    <div
      @click="onClick"
      @dblclick="onDblClick"
      @keyup.enter="onDblClick"
      :tabindex="myTI"
      :class="[treeNodeClass, errorClass, selectedClass]"
      class="text"
      ref="myText"
    >
      <i :class="iconClass"></i>
      <span
        v-for="(data, index) in node.text"
        :key="index"
        :currentData="data"
        :index="index"
        class="sub-text"
        >{{ data }}</span
      >
    </div>
    <div v-if="clicked && node.children && node.children.length > 0">
      <ul v-for="(element, index) in node.children" :key="index">
        <tree-node :node="element" @info-event="emitInfo"></tree-node>
      </ul>
    </div>
  </li>
</template>


<script>
import PageList from "./Buttons/PageList";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      clicked: false,
      modalOpen: false,
      responseData: null,
      listLength: 50,
      selectedPage: null,
      //caret right/bottom
      iconClass: "",
      //node / leaf
      treeNodeClass: "",
      errorClass: "",
      downX: 0,
      upX: 0,
      myTI: -1,
    };
  },
  name: "tree-node",
  props: ["node"],
  methods: {
    emitInfo() {
      this.$emit("info-event");
    },
    onClick() {
      if (this.getLogType === "admin_task_log")
        this.$store.commit("setCurrentTreeNode", this.node);
    },
    onDblClick(event) {
      this.clicked = !this.clicked;
      if (this.node.children && this.node.children.length > 0) {
        if (this.clicked) {
          this.iconClass = "el-icon-caret-bottom";
        } else {
          this.iconClass = "el-icon-caret-right";
        }
      } else {
        this.emitInfo();
      }
    },
    onPageList(value) {
      this.selectedPage = value;
      if (this.clicked) {
        let Y =
          this.$refs.myText.getBoundingClientRect().y + window.pageYOffset;
        window.scrollTo(0, Y);
      }
    },
    updateClasses() {
      this.node.text = Array.isArray(this.node.text)
        ? this.node.text
        : [this.node.text];
      if (this.node.children && this.node.children.length > 0) {
        this.myTI = 0;
        this.treeNodeClass = "node";
        if (this.clicked) this.iconClass = "el-icon-caret-bottom";
        else this.iconClass = "el-icon-caret-right";
      } else {
        this.treeNodeClass = "leaf";
      }
      if (
        this.node.result &&
        this.node.result !== 0 &&
        this.node.typeNode !== "D"
      ) {
        this.errorClass = "error";
      } else this.errorClass = "";
    },
  },
  created() {
    this.updateClasses();
  },
  updated() {
    this.updateClasses();
  },
  computed: {
    pageCount() {
      var pageC = Math.ceil((this.node.children.length - 1) / this.listLength);
      return pageC;
    },
    longListCounter() {
      if (this.selectedPage) {
        return this.selectedPage;
      }
      return 1;
    },
    selectedClass() {
      if (this.currentTreeNode && this.node === this.currentTreeNode)
        return "selected-node";
      else return "";
    },
    ...mapGetters(["getModalData", "getLogType", "currentTreeNode"]),
  },
  components: {
    PageList,
  },
};
</script>

<style scoped>
:root {
  --margin-left: 25px;
}
li {
  margin-left: 20px;
}
.text.node {
  font-weight: 600;
}
.text.leaf {
  margin-left: 8px;
}
.text.leaf:before {
  content: "\2022";
  margin-right: 3px;
}
.text.error {
  color: #901212;
}
.text.error::after {
  content: "\2731";
  font-weight: 900;
  display: inline-block;
  transform: scale(0.65);
}
.text.error i {
  color: red;
}
.text {
  cursor: pointer;
  line-height: 20px;
  -webkit-user-select: none; /* Chrome all / Safari all */
  -moz-user-select: none; /* Firefox all */
  -ms-user-select: none; /* IE 10+ */
  user-select: none;
}
.text:hover {
  background-color: var(--active-color-lighter);
}
.text.selected-node {
  /* outline-width: 1px;
  outline-color: var(--main-background); */
  background-color: var(--active-color-lighter);
}
.text:focus {
  outline: none;
}
.tbc-text {
  margin-left: var(--margin-left);
}
.page-list {
  margin-left: var(--margin-left);
}

.info-button {
  padding: 5px 10px 5px 9px;
  position: relative;
  top: -1px;
}
.modal {
  position: fixed;
  top: 0;
  left: 0;
}
.main-list ul {
  padding-left: 20px;
  margin: 6px 0;
}
ul {
  list-style: none;
}
.sub-text {
  font-family: "Roboto Mono", monospace;
  display: inline-block;
  padding-right: 2em;
  /* overflow-wrap: break-word; */
  word-break: break-all;
  max-width: 100%;
}
.sub-text:last-of-type {
  padding-right: 5px;
}
</style>
